import React, { useEffect, useState } from 'react';

import Input from 'components/partials/input/input';

const formatAmount = (value: number | null | undefined): string =>
  value == null ? '' : Math.round(value).toLocaleString('en-US');

export interface AwardAmountCellProps {
  value: number | null | undefined;
  onCommit: (value: number | null) => void;
  'data-testid'?: string;
}

/**
 * Awarding-amount cell with local draft state that commits on blur, so typing
 * does not re-render the whole table on every keystroke. The committed server
 * value flows back in via `value`.
 */
const AwardAmountCell = ({
  value,
  onCommit,
  'data-testid': dataTestId = 'award-amount-cell',
}: AwardAmountCellProps) => {
  const [draft, setDraft] = useState(() => formatAmount(value));

  useEffect(() => {
    setDraft(formatAmount(value));
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const raw = e.target.value.replace(/[^0-9]/g, '');

    setDraft(raw ? Number.parseInt(raw, 10).toLocaleString('en-US') : '');
  };

  const handleBlur = (): void => {
    const raw = draft.replace(/[^0-9]/g, '');

    onCommit(raw ? Number.parseInt(raw, 10) : null);
  };

  return (
    <Input
      type="text"
      value={draft}
      startAdornment="$"
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder="0"
      aria-label="Awarding amount"
      inputCustomClass="h-8 !py-1 text-sm"
      inputWrapperCustomClass="!m-0"
      data-testid={dataTestId}
    />
  );
};

export default AwardAmountCell;
